import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';

export const IDP_ACTIONS = {
  GET_IDP_TOKEN: '@regulatory/idp/getIDPToken'
};

export const getIDPToken = (redirectURL) => {
  http.get('core-service/v1/core/token').pipe(
    map(
      (resp) => {
        console.log('I am  going to', redirectURL, resp);
      },
      (error) => {
        console.error('I am not going to', redirectURL, error);
      }
    )
  );
};
